import { Action } from 'redux';

import { UpdateDataFreshnessPolicy } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { IContentInfo } from '../../ts/models/IContentInfo';

export interface UpdateDataFreshnessPolicyAction extends Action {
  workbooks: IContentInfo[];
}

export function updateDataFreshnessPolicy(workbooks: IContentInfo[]): UpdateDataFreshnessPolicyAction {
  return {
    type: UpdateDataFreshnessPolicy,
    workbooks
  };
}

const isUpdateDataFreshessPolicyAction = isActionFactory<UpdateDataFreshnessPolicyAction>(UpdateDataFreshnessPolicy);
